// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"d0695a6c","120":"f67edc7a","239":"34423ed4","453":"b960153a","455":"fef6f798","551":"b4615afa","977":"c369952d"}[chunkId] + ".chunk.js";
};